// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2w1C3","title":"Header_title__2Timd","left":"Header_left__1S7dx","clinicName":"Header_clinicName__1r5r1"};